<template>
  <b-card
    :title="
      `Manage instructions for Payment Option : ${this.$route.params.name} `
    "
  >
    <b-row>
      <b-col md="3">
        <b-link :to="{ name: 'Fops-list' }">
          <feather-icon icon="ArrowLeftIcon" />
          <span class="align-middle ml-50">Back to List</span>
        </b-link>
      </b-col>
    </b-row>

    <h3></h3>
    <br />
    <hr />

    <b-row>
      <b-col md="1" />
      <h5 class="col-xs-1 center-block">
        Add Language type
      </h5>
      <b-col cols="3">
        <b-form-group label-for="payment-option">
          <b-form-select
            id="merchantId"
            v-model="selected"
            :options="filteredLanguage"
          />
        </b-form-group>
      </b-col>
      <b-col>
        <b-button
          v-if="selected !== null"
          variant="primary"
          type="submit"
          @click.prevent="AddLanguage"
        >
          Add
        </b-button>
      </b-col>
    </b-row>

    <!-- Row Loop -->

    <b-col v-for="(item, index) in items" :key="index" ref="row">
      <!-- <b-col md="2">
            <b-form-group
              label="isNew"
              label-for="item-isnew"
            >
              <b-form-input
                id="item-steps"
                v-model="item.isNew"
                type="text"
              />
            </b-form-group>
          </b-col> -->
      <!-- steps-->

      <div class="mb-2 " v-for="(lang, index_) in Languages" :key="index_">
        <b-button
          aria-controls="collapse-4"
          @click="item.visible = !item.visible"
          v-ripple
          class="text-center culture"
          data-md-content="200"
          v-if="item.culture == lang.value"
          >{{ lang.text }}</b-button
        >
      </div>
      <b-collapse v-model="item.visible" class="mt-2">
        <b-col>
          <b-row
            md="10"
            v-for="(instruction_Items, index_2) in item.instructions"
            :key="index_2"
          >
            <b-col>
              <b-form-group label="Steps" label-for="item-steps">
                <b-form-input
                  id="item-steps"
                  v-model="instruction_Items.steps"
                  type="text"
                />
              </b-form-group>
            </b-col>

            <!-- Item description -->
            <b-col>
              <b-form-group label="Description" label-for="item-description">
                <b-form-input
                  id="item-description"
                  v-model="instruction_Items.description"
                  type="text"
                  placeholder="description"
                />
              </b-form-group>
            </b-col>

            <!-- sequence -->
            <b-col md="1">
              <b-form-group label="Sequence" label-for="sequence">
                <b-form-input
                  type="number"
                  id="sequence"
                  v-model.number="instruction_Items.sequence"
                />
              </b-form-group>
            </b-col>

            <!-- Remove Button -->
            <b-col md="2" class="mb-50">
              <b-button
                v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                variant="outline-danger"
                class="mt-0 mt-md-2"
                @click="removeItem(index_2, item.culture)"
              >
                <feather-icon icon="XIcon" class="mr-25" />
                <span>Delete</span>
              </b-button>
            </b-col>
            <!-- ADD Button -->

            <b-col cols="12">
              <b-col v-if="item.instructions.length - 1 == index_2">
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  @click="repeateAgain(item.culture)"
                >
                  <feather-icon icon="PlusIcon" class="mr-25" />
                  <span>Add New</span>
                </b-button>
              </b-col>
              <hr />
            </b-col>
          </b-row>
        </b-col>
      </b-collapse>
    </b-col>
    <b-col>
      <b-button class="center" variant="success" @click="submitInstructions">
        <span>Save</span>
      </b-button>
    </b-col>

    <!-- loadings -->
    <b-overlay :show="isLoading" no-wrap rounded="sm" />
  </b-card>
</template>

<script>
import {
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BButton,
  BCard,
  BOverlay,
  BLink,
  BDropdown,
  BDropdownItem,
  BFormSelect,
  VBToggle,
  BCollapse,
  BCardBody,
} from "bootstrap-vue";
import { heightTransition } from "@core/mixins/ui/transition";
import Ripple from "vue-ripple-directive";
import axios from "@axios";

export default {
  components: {
    BCollapse,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BRow,
    BCol,
    BButton,
    BCard,
    BOverlay,
    BLink,
    BDropdown,
    BDropdownItem,
    VBToggle,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      paymentOptionsId: this.$route.params.id,
      items: [
        {
          culture: "",
          instructions: [
            {
              steps: "",
              description: "",
              sequence: 1,
            },
          ],

          visible: true,
        },
      ],
      Languages: [
        {
          value: null,
          text: "--Choose Language--",
          disabled: true,
        },
        {
          value: "en",
          text: "English",
        },
        {
          value: "am",
          text: "Amharic",
        },
        {
          value: "ti",
          text: "Tigrinya",
        },
        {
          value: "om",
          text: "Afaan Oromoo",
        },
        {
          value: "so",
          text: "Somali",
        },
        {
          value: "fr",
          text: "Francais",
        },
        {
          value: "es",
          text: "Espanol",
        },
        {
          value: "ar",
          text: "Arabic",
        },
        {
          value: "pt",
          text: "Portugues",
        },
        {
          value: "it",
          text: "Italiano",
        },
        {
          value: "zh",
          text: "Chinese",
        },
        {
          value: "ja",
          text: "Japanese",
        },
        {
          value: "ru",
          text: "Russian",
        },
        {
          value: "ko",
          text: "Korean",
        },
        {
          value: "th",
          text: "Thai",
        },
      ],
      filteredLanguage: [
        {
          value: null,
          text: "--Choose Language--",
          disabled: true,
        },
        {
          value: "en",
          text: "English",
        },
        {
          value: "am",
          text: "Amharic",
        },
        {
          value: "ti",
          text: "Tigrinya",
        },
        {
          value: "om",
          text: "Afaan Oromoo",
        },
        {
          value: "so",
          text: "Somali",
        },
        {
          value: "fr",
          text: "Francais",
        },
        {
          value: "es",
          text: "Espanol",
        },
        {
          value: "ar",
          text: "Arabic",
        },
        {
          value: "pt",
          text: "Portugues",
        },
        {
          value: "it",
          text: "Italiano",
        },
        {
          value: "zh",
          text: "Chinese",
        },
        {
          value: "ja",
          text: "Japanese",
        },
        {
          value: "ru",
          text: "Russian",
        },
        {
          value: "ko",
          text: "Korean",
        },
        {
          value: "th",
          text: "Thai",
        },
      ],
      selected: null,
      nextSequence: 1,
      instructions: [],
      isLoading: false,
    };
  },
  mounted() {
    this.initTrHeight();
  },
  created() {
    this.fetchData();
    window.addEventListener("resize", this.initTrHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  methods: {
    AddLanguage() {
      console.log(this.selected);
      this.nextSequenceLanguage += 1;
      this.items.push({
        culture: this.selected,
        instructions: [
          {
            steps: "",
            description: "",
            sequence: 1,
          },
        ],
      });
      this.filteredLanguage = this.filteredLanguage.filter(
        (f) => f.value !== this.selected
      );
      this.selected = null;

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
      });
    },
    repeateAgain(culture) {
      this.nextSequence += 1;
      const filterd = this.items.filter((f) => f.culture === culture);
      filterd[0].instructions.push({
        steps: "",
        description: "",
        sequence: (filterd[0].instructions.length ?? 0) + 1,
      });

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
      });
    },
    removeItem(index, culture) {
      this.nextSequence -= 1;
      const filterd = this.items.filter((f) => f.culture === culture);
      filterd[0].instructions.splice(index, 1);
      this.items = this.items.filter((f) => f.instructions.length !== 0);
      this.filteredLanguage = this.Languages;
      this.items.forEach((item) => {
        this.filteredLanguage = this.filteredLanguage.filter(
          (f) => f.value !== item.culture
        );
      });
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },
    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form);
      });
    },
    submitInstructions() {
      this.$store.dispatch(
        "config/getActionPrivilege",
        "MerchantFOP-ManageInstructions"
      );
      this.isLoading = true;
      axios
        .put("/PaymentOptions/api/V1.0/PaymentOptions/UpdateInstructions", {
          paymentOptionId: parseInt(this.$route.params.id, 10),
          instructionRequest: this.items,
        })
        .then((response) => {
          console.log(response);
          this.isLoading = false;
          this.$bvModal
            .msgBoxOk("Data was submitted successfully", {
              title: "Confirmation",
              size: "sm",
              buttonSize: "sm",
              okVariant: "success",
              headerClass: "p-2 border-bottom-0",
              footerClass: "p-2 border-top-0",
              centered: true,
            })
            .then((result) => {
              if (result) {
                this.$router.push({ name: "Fops-list" });
              }
            });
        })
        .catch((error) => {
          this.isLoading = false;
          console.log(error);
          this.$bvModal
            .msgBoxOk(error.data.message, {
              title: "Confirmation",
              size: "sm",
              buttonSize: "sm",
              okVariant: "success",
              headerClass: "p-2 border-bottom-0",
              footerClass: "p-2 border-top-0",
              centered: true,
            })
            .then((value) => {
              this.boxTwo = value;
            });
          // this.$refs.loginForm.setErrors(error)
        });
    },
    // API
    fetchData() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "MerchantFOP-View");

      axios
        .get(
          `/PaymentOptions/api/V1.0/PaymentOptions/GetInstructions?paymentOptionId=${this.paymentOptionsId}`
        )
        .then((res) => {
          this.items = [];
          res.instructions.forEach((item) => {
            this.items.push({
              culture: item.culture,
              instructions: [...item.instructions],
            });
            this.filteredLanguage = this.filteredLanguage.filter(
              (f) => f.value !== item.culture
            );
          });

          this.initTrHeight();
          this.isLoading = false;
        })
        .catch((res) => {
          this.isLoading = false;
          // if (this.items.length === 0) {
          //   this.items.push({
          //     id: 0,
          //     steps: '',
          //     description: '',
          //     sequence: 1,
          //   })
          //   this.nextSequence += 1
          // }
        });
    },
  },
};
</script>
<style>
.culture {
  width: 100%;
}
b-form-input {
  width: 100%;
}
</style>
